module.exports = __webpack_public_path__ + "img/31e738d31efa52186c9e89d1b5234b40.png";